import React from 'react';
import { mixpanelService } from '../../core/services/mixpanel';
import { viewEvents } from '../../core/services/mixpanelEvents';

interface Props {
  children: React.ReactNode;
  fallback: React.ReactNode;
}

interface State {
  hasError: boolean;
}

// Class component because React exposes no hook equivalent of componentDidCatch.
class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    mixpanelService.trackError(
      viewEvents.LANDING_PAGE_VIEWED,
      `Render: ${error.name}: ${error.message}`
    );
  }

  render() {
    return this.state.hasError ? this.props.fallback : this.props.children;
  }
}

export default ErrorBoundary;
